// shared-components/components/NavCard.jsx
import React from 'react';
import { useBreakpoint } from '../hooks/useBreakpoint';

function NavCard({ 
  icon,
  title,
  description,
  onClick,
  badge = null,
  color = 'var(--compudopt-blue)' // Add color prop for flexibility
}) {
  const { isMobile } = useBreakpoint();
  
  return (
    <button
      onClick={onClick}
      className="nav-card"
      style={{
        position: 'relative',
        width: '100%',
        textAlign: 'left',
        padding: isMobile ? 'var(--space-4)' : 'var(--space-6)',
        minHeight: isMobile ? '80px' : undefined, // Ensure adequate touch height
        borderRadius: 'var(--radius-lg)',
        background: 'var(--bg-primary)',
        border: '2px solid var(--border-default)',
        cursor: 'pointer',
        transition: 'all var(--duration-page) var(--ease-out)',
        boxShadow: 'var(--shadow-md)'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = 'var(--compudopt-blue)';
        e.currentTarget.style.boxShadow = 'var(--shadow-xl)';
        e.currentTarget.style.transform = 'translateY(-2px)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = 'var(--border-default)';
        e.currentTarget.style.boxShadow = 'var(--shadow-md)';
        e.currentTarget.style.transform = 'translateY(0)';
      }}
    >
      {/* Badge */}
      {badge && (
        <div 
          style={{
            position: 'absolute',
            top: 'var(--space-4)',
            right: 'var(--space-4)',
            padding: 'var(--space-1) var(--space-2)',
            borderRadius: 'var(--radius-full)',
            background: 'var(--compudopt-green)',
            color: 'var(--text-on-primary)',
            fontSize: '12px',
            fontWeight: 'var(--font-semibold)'
          }}
        >
          {badge}
        </div>
      )}
      
      {/* Content */}
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 'var(--space-4)' }}>
        {/* Icon Container */}
        <div 
          className="nav-card-icon"
          style={{ 
            width: isMobile ? '48px' : '64px',
            height: isMobile ? '48px' : '64px',
            borderRadius: 'var(--radius-md)',
            display: 'grid',
            placeItems: 'center',
            fontSize: isMobile ? '24px' : '32px',
            flexShrink: 0,
            background: color || 'var(--compudopt-blue)',
            boxShadow: 'var(--shadow-md)'
          }}
        >
          {typeof icon === 'string' ? (
            <span role="img" aria-hidden="true">{icon}</span>
          ) : (
            icon
          )}
        </div>
        
        {/* Text Content */}
        <div style={{ flex: 1, minWidth: 0 }}>
          <h3 style={{ 
            fontSize: isMobile ? '16px' : '20px',
            fontWeight: 'var(--font-semibold)',
            color: 'var(--gray-900)',
            marginBottom: 'var(--space-1)',
            transition: 'color var(--duration-normal)'
          }}>
            {title}
          </h3>
          <p style={{ 
            fontSize: isMobile ? '13px' : '14px',
            color: 'var(--gray-600)',
            lineHeight: 'var(--leading-normal)',
            overflow: 'hidden',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical'
          }}>
            {description}
          </p>
        </div>
        
        {/* Arrow */}
        <div 
          className="nav-card-arrow"
          style={{ 
            color: 'var(--gray-400)',
            fontSize: '20px',
            transition: 'all var(--duration-normal)',
            marginTop: '20px'
          }}
        >
          →
        </div>
      </div>
    </button>
  );
}

export default NavCard;